import {buildServerCall} from '../../services/wcfService';
import {getConnection} from '../../_shared/GWTBridge/invoke/genPage';

export function getActionsPackMapping(formInnerId: string) {
    const methodName = 'GeneralFormActivationsPacks';
    const reason = 'GeneralFormActivationsPacks';
    const parameters = {form: [formInnerId]};
    return buildServerCall(methodName, parameters, reason, false, getConnection);
}

export function getSubformsPackMapping(formInnerId: string) {
    const methodName = 'GeneralFormSonsPacks';
    const reason = 'GeneralFormSonsPacks';
    const parameters = {form: [formInnerId]};
    return buildServerCall(methodName, parameters, reason, false, getConnection);
}
